/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Eventaistartpicturesskipped4Inputs */

const en_eventaistartpicturesskipped4 = /** @type {(inputs: Eventaistartpicturesskipped4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`At most ${i?.count} pictures, the rest were left out.`)
};

const de_eventaistartpicturesskipped4 = /** @type {(inputs: Eventaistartpicturesskipped4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Höchstens ${i?.count} Bilder, der Rest wurde nicht übernommen.`)
};

/**
* | output |
* | --- |
* | "At most {count} pictures, the rest were left out." |
*
* @param {Eventaistartpicturesskipped4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartpicturesskipped4 = /** @type {((inputs: Eventaistartpicturesskipped4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartpicturesskipped4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartpicturesskipped4(inputs)
	return de_eventaistartpicturesskipped4(inputs)
});
export { eventaistartpicturesskipped4 as "eventAiStartPicturesSkipped" }